import { createFileRoute } from '@tanstack/react-router';
import { GroupsReport } from '@/components/groups/groups-report';
import { useProjects } from '@/hooks/use-projects';

export const Route = createFileRoute('/_auth/_side-layout/groups')({
  component: GroupsPage,
});

// Keyed by project so a sidebar project switch clears the selected group.
function GroupsPage() {
  const { projectId } = useProjects();
  return <GroupsReport key={projectId ?? 'none'} />;
}
